import { Loader } from "@googlemaps/js-api-loader";
import VideoModal from '../_modal/VideoModal.js';
import { i18n, mapLanguage } from '../i18n.js';
import { escapeAttr } from '../utility.js';
import { GOOGLE_MAPS_API_KEY } from '../config.js';

// 「#」はプライベートプロパティを表す慣習
class GoogleMap {
  #map;
  #markers = [];
  #panelFlag = false;
  #locationJsonData;
  #dom = {}; // DOM要素をキャッシュするためのプライベートプロパティ
  #path;
  #currentSpotIndex = -1;

  // エリア別の中心地点を定数として定義
  static CENTER_COORDINATES = {
    default: { lat: 37.1386733525524, lng: 139.70973119029608, zoom: 9 },
    minamiaizu: { lat: 37.153236929654405, lng: 139.61934786435037, zoom: 10.5 },
    shimogo: { lat: 37.2540611, lng: 139.6940965, zoom: 11.5 },
    aizuwakamatsu: { lat: 37.4521636, lng: 139.8114766, zoom: 11 },
  };

  // ピンのSVGデータを定数として定義
  static PIN_DATA = {
    default: `<svg width="19" height="32" viewBox="0 0 19 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.37408 0.04C9.10408 0.04 8.84408 0.38 8.57408 0.4C8.30408 0.42 8.04408 0.46 7.78408 0.51C7.52408 0.56 7.15408 0.21 6.89408 0.28C6.63408 0.35 6.40408 0.58 6.15408 0.67C5.90408 0.76 5.56408 0.71 5.32408 0.82C5.08408 0.93 4.89408 1.2 4.65408 1.34C4.41408 1.48 4.30408 1.8 4.08408 1.95C3.86408 2.1 3.53408 2.13 3.32408 2.3C3.11408 2.47 2.90408 2.66 2.71408 2.85C2.52408 3.04 2.28408 3.21 2.11408 3.42C1.94408 3.63 1.79408 3.87 1.63408 4.09C1.47408 4.31 1.58408 4.7 1.45408 4.94C1.32408 5.18 0.874084 5.25 0.764084 5.5C0.654084 5.75 0.964084 6.16 0.864084 6.42C0.764084 6.68 0.644084 6.9 0.574084 7.16C0.504084 7.42 0.0540841 7.59 0.0140841 7.86C-0.0259159 8.13 0.0340841 8.42 0.0140841 8.69C-0.00591592 8.96 0.0440841 9.24 0.0440841 9.51C0.0440841 9.77 0.164084 10.02 0.184084 10.29C0.204084 10.56 0.344084 10.79 0.374084 11.06C0.404084 11.33 0.524084 11.55 0.574084 11.82C0.624084 12.09 0.684084 12.32 0.744084 12.58C0.804084 12.84 0.774084 13.1 0.834084 13.36C0.894084 13.62 0.944084 13.87 1.01408 14.12C1.08408 14.37 0.884084 14.7 0.964084 14.96C1.04408 15.22 1.20408 15.44 1.28408 15.69C1.36408 15.94 1.37408 16.21 1.46408 16.46C1.55408 16.71 1.63408 16.96 1.72408 17.2C1.81408 17.44 1.72408 17.77 1.81408 18.01C1.90408 18.25 2.45408 18.32 2.55408 18.57C2.65408 18.82 2.29408 19.25 2.39408 19.49C2.49408 19.73 2.75408 19.91 2.85408 20.16C2.95408 20.41 3.06408 20.65 3.16408 20.89C3.26408 21.13 3.51408 21.31 3.62408 21.55C3.73408 21.79 3.97408 21.97 4.08408 22.21C4.19408 22.45 4.45408 22.62 4.57408 22.85C4.69408 23.08 4.48408 23.48 4.60408 23.72C4.72408 23.96 4.65408 24.29 4.77408 24.52C4.89408 24.75 5.42408 24.78 5.54408 25.01C5.66408 25.24 5.36408 25.71 5.48408 25.93C5.60408 26.15 6.21408 26.14 6.33408 26.37C6.45408 26.6 6.49408 26.89 6.62408 27.11C6.75408 27.35 6.78408 27.63 6.91408 27.85C7.04408 28.09 7.39408 28.19 7.52408 28.41C7.66408 28.65 7.38408 29.11 7.51408 29.33C7.65408 29.57 7.87408 29.75 8.00408 29.96C8.15408 30.21 8.49408 30.31 8.62408 30.51C8.78408 30.77 8.54408 31.24 8.66408 31.42C8.95408 31.86 9.61408 31.91 9.61408 31.85C9.61408 31.91 9.53408 31.68 9.82408 31.24C9.94408 31.06 10.1341 30.86 10.2941 30.6C10.4241 30.4 10.6241 30.21 10.7741 29.97C10.9041 29.76 11.0741 29.56 11.2241 29.32C11.3541 29.1 11.5341 28.9 11.6641 28.66C11.7941 28.44 11.8741 28.19 12.0141 27.95C12.1441 27.73 12.3941 27.57 12.5241 27.33C12.6541 27.09 12.7041 26.83 12.8341 26.6C12.9641 26.37 12.9041 26.05 13.0341 25.81C13.1641 25.57 13.2741 25.34 13.3941 25.11C13.5141 24.88 13.8541 24.76 13.9741 24.52C14.0941 24.28 14.0841 23.99 14.2041 23.75C14.3241 23.51 14.2241 23.18 14.3441 22.94C14.4641 22.7 14.4741 22.42 14.5841 22.18C14.6941 21.94 15.1641 21.87 15.2741 21.63C15.3841 21.39 15.4041 21.11 15.5141 20.87C15.6241 20.63 15.6241 20.34 15.7341 20.1C15.8441 19.86 15.9741 19.63 16.0741 19.38C16.1741 19.13 16.3541 18.92 16.4541 18.68C16.5541 18.44 16.4541 18.11 16.5541 17.86C16.6541 17.61 17.1241 17.51 17.2141 17.26C17.3041 17.01 17.2741 16.71 17.3641 16.47C17.4541 16.23 17.1741 15.85 17.2541 15.6C17.3341 15.35 17.4941 15.12 17.5641 14.87C17.6341 14.62 17.6441 14.35 17.7141 14.09C17.7841 13.83 18.1241 13.65 18.1841 13.4C18.2441 13.15 18.4841 12.92 18.5341 12.66C18.5841 12.4 18.7241 12.15 18.7641 11.89C18.8041 11.63 18.5441 11.31 18.5741 11.05C18.6041 10.79 18.4541 10.51 18.4641 10.25C18.4841 9.98 18.4641 9.73 18.4641 9.48C18.4641 9.21 18.8241 8.92 18.8041 8.66C18.7841 8.4 18.4641 8.16 18.4141 7.89C18.3641 7.62 18.4741 7.32 18.4141 7.06C18.3541 6.8 18.3041 6.52 18.2041 6.27C18.1041 6.02 17.8141 5.85 17.7041 5.6C17.5941 5.35 17.5041 5.1 17.3741 4.87C17.2441 4.64 17.0941 4.41 16.9441 4.19C16.7941 3.97 16.6141 3.77 16.4441 3.56C16.2741 3.35 16.3641 2.89 16.1641 2.7C15.9641 2.51 15.5541 2.55 15.3441 2.38C15.1341 2.21 14.9041 2.07 14.6841 1.91C14.4641 1.75 14.4141 1.3 14.1841 1.17C13.9541 1.04 13.6541 0.97 13.4141 0.85C13.1741 0.73 12.7541 1.03 12.5041 0.94C12.2541 0.85 12.0541 0.6 11.7941 0.53C11.5341 0.46 11.3041 0.26 11.0341 0.21C10.7641 0.16 10.4541 0.53 10.1841 0.51C9.91408 0.49 9.67408 0 9.40408 0L9.37408 0.04Z" fill="#FF5B5B"/></svg>`,
  };

  constructor(el, spotController = null) {
    this.#dom.el = el;
    this.#dom.location = document.querySelector('[data-js="locations"]');
    this.#dom.drawer = document.querySelector('[data-js="drawer"]');
    this.#dom.drawerCloser = document.querySelectorAll('[data-js="drawer-closer"]');
    this.#dom.drawerUnit = document.querySelector('[data-js="drawer-unit"]');
    this.spotController = spotController; // SpotControllerの参照を保持
    this.videoModal = new VideoModal(); // 動画モーダルインスタンス

    this.#path = this.#dom.el.dataset.path;

    this.#locationJsonData = this.#dom.location ? JSON.parse(this.#dom.location.textContent) : [];

    // イベントハンドラーを事前にバインド（重複防止のため）
    this.boundFilterMarkers = this.filterMarkers.bind(this);

    // マップコンテナの初期スタイル設定
    this.#setupMapContainerAnimation();

    this.loader = new Loader({
      // APIキーは本番環境ではサーバーサイドで管理することをお勧めします
      // apiKey: 'AIzaSyAZGVqmzFzOB3NTINBCuFLMv3X4vvB8GfE', // 開発用API
      apiKey: GOOGLE_MAPS_API_KEY, // 本番用（ローカルは .env の API で上書き）
      version: 'weekly',
      libraries: ['places'],
      language: mapLanguage, // 地図ラベルを表示言語に合わせる
    });
    /**
     * mapTypeId
     * roadmap: 道路地図ビューを表示します。これは、デフォルトのマップタイプです。
     * satellite: Google Earth の衛星画像を表示します。
     * hybrid: 通常ビューと衛星画像ビューの複合ビューを表示します。
     * terrain: 地形情報に基づいた物理地図を表示します。
     */
    this.mapOptions = {
      center: GoogleMap.CENTER_COORDINATES['default'],
      zoom: GoogleMap.CENTER_COORDINATES['default'].zoom,
      fullscreenControl: false, // フルスクリーンコントロールを有効にする
      // fullscreenControlOptions: {
      //   position: google.maps.ControlPosition.BOTTOM_LEFT // 例: 左下に配置
      // },
      mapTypeControl: false, // マップタイプコントロールを有効にする
      // mapTypeControlOptions: {
      //   position: google.maps.ControlPosition.TOP_LEFT // 例: 左上に配置
      // }
      mapTypeId: 'satellite',
      mapId: 'DEMO_MAP_ID', // AdvancedMarkerElement requires a Map ID.
    };

    this.#bindEventHandlers();
  }

  // イベントハンドラをまとめてバインドするプライベートメソッド
  #bindEventHandlers() {
    // `this`のコンテキストを保持するため、アロー関数を使用するか、bindを明示的に行う
    if (this.#dom.drawerCloser) this.#dom.drawerCloser.forEach(closer => closer.addEventListener('click', this.toggleInformationPanel.bind(this)));
  }

  // フィルターボタンのイベントハンドラーをバインドするプライベートメソッド
  #bindFilterEventHandlers() {
    const areas = document.querySelectorAll('.map-filter-list__trigger');
    areas.forEach(area => {
      // 既存のイベントリスナーを削除（重複防止）
      area.removeEventListener('click', this.boundFilterMarkers);
      // 新しいイベントリスナーを追加
      area.addEventListener('click', this.boundFilterMarkers);
    });
  }

  async #init() {
    try {
      // ローディング表示
      this.#showLoadingAnimation();
      
      await new Promise(resolve => setTimeout(resolve, 1000));
      await this.loader.load();

      // AdvancedMarkerElement用のmarkerライブラリをロード
      const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
      this.AdvancedMarkerElement = AdvancedMarkerElement;

      this.#map = new google.maps.Map(this.#dom.el, this.mapOptions);

      // 提供されたスタイルJSONをStyledMapType形式に変換
      const customMapStyles = [
        // 都市域 - infrastructure.urbanArea → landscape.man_made
        {
          featureType: 'landscape.man_made',
          elementType: 'geometry.fill',
          stylers: [{ color: '#657b68' }, { visibility: 'on' }]
        },
        // 自然の土地被覆 - natural.land.landCover → landscape.natural
        {
          featureType: 'landscape.natural',
          elementType: 'geometry.fill',
          stylers: [{ color: '#6d9f5b' }, { visibility: 'on' }]
        },
        // 森林 - natural.land.landCover.forest → poi.park
        {
          featureType: 'poi.park',
          elementType: 'geometry.fill',
          stylers: [{ color: '#557a57' }, { visibility: 'on' }]
        },
        // 水域 - natural.water → water
        {
          featureType: 'water',
          elementType: 'geometry.fill',
          stylers: [{ color: '#5dafab' }]
        },
        // POI全般を非表示 - pointOfInterest
        {
          featureType: 'poi',
          elementType: 'all',
          stylers: [{ visibility: 'off' }]
        },
        // 個別POIカテゴリも明示的に非表示
        {
          featureType: 'poi.business',
          elementType: 'all',
          stylers: [{ visibility: 'off' }]
        },
        {
          featureType: 'poi.medical',
          elementType: 'all',
          stylers: [{ visibility: 'off' }]
        },
        {
          featureType: 'poi.place_of_worship',
          elementType: 'all',
          stylers: [{ visibility: 'off' }]
        },
        {
          featureType: 'poi.school',
          elementType: 'all',
          stylers: [{ visibility: 'off' }]
        },
        {
          featureType: 'poi.attraction',
          elementType: 'all',
          stylers: [{ visibility: 'off' }]
        },
        // 自然保護区 - pointOfInterest.recreation.natureReserve
        {
          featureType: 'poi.park',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#3e6365' }, { visibility: 'on' }]
        },
        // 政治的境界を非表示 - political
        {
          featureType: 'administrative',
          elementType: 'all',
          stylers: [{ visibility: 'off' }]
        },
        // 道路シールドを非表示 - infrastructure.roadNetwork.roadShield
        {
          featureType: 'road',
          elementType: 'labels.icon',
          stylers: [{ visibility: 'off' }]
        },
        // 道路ラベルも調整
        {
          featureType: 'road.highway',
          elementType: 'labels.icon',
          stylers: [{ visibility: 'off' }]
        }
      ];

      // カスタムスタイルを適用
      const styledMapType = new google.maps.StyledMapType(customMapStyles, {
        name: 'Aizu Custom Style'
      });
      
      this.#map.mapTypes.set('aizu_custom', styledMapType);
      this.#map.setMapTypeId('aizu_custom');
      
      // マップ読み込み完了後のアニメーション
      google.maps.event.addListenerOnce(this.#map, 'tilesloaded', () => {
        this.#showMapWithAnimation();
        setTimeout(() => {
          this.#hideLoadingAnimation();
        }, 250);
        setTimeout(() => {
          // Get the currently active filter from spotController
          const currentFilter = this.spotController ? this.spotController.getCurrentFilterKey() : 'default';
          
          if (currentFilter !== 'default') {
            this.#fitAreaBounds(currentFilter);
            this.#createMarkersWithFilter(currentFilter);
          } else {
            this.#createMarkers('default', true); // 初期表示時はアニメーション有効
          }
          this.#addMarkerClickListeners();
          this.#bindFilterEventHandlers(); // 地図ロード完了時にフィルターイベントをバインド
        }, 300);
      });
    } catch (e) {
      console.error("Google Maps API のロードに失敗しました:", e);
      this.#hideLoadingAnimation();
    }
  }

  #addMarkerClickListeners() {
    this.#markers.forEach(marker => {
      marker.addListener('click', () => { // アロー関数でthisのコンテキストを保持
        this.#createInformationPanel(marker.locationData);
      });
    });
  }

  // マーカーを完全にクリアするプライベートメソッド
  #clearAllMarkers() {
    this.#markers.forEach(marker => {
      if (marker) {
        if (typeof marker.setMap === 'function') {
          marker.setMap(null);
        } else {
          marker.map = null;
        }
      }
    });
    this.#markers = [];
  }

  #createMarkers(pinArea, withAnimation = true) {
    // 既存のマーカーをクリア
    this.#clearAllMarkers();

    this.#locationJsonData.filter(location => location.position !== null).forEach((location, index) => {
      // Create HTML element for the marker content
      const markerContent = document.createElement('div');
      markerContent.className = 'custom-pin';
      markerContent.innerHTML = GoogleMap.PIN_DATA['default'];

      const marker = new this.AdvancedMarkerElement({
        position: location.position,
        map: this.#map,
        content: markerContent,
        title: location.title,
        anchorLeft: '-50%',
        anchorTop: '-100%',
      });

      // 位置データをマーカーに関連付け
      marker.locationData = location;

      // 時差でマーカーを表示（アニメーション有効時）
      if (withAnimation) {
        marker.map = null; // 一旦非表示
        setTimeout(() => {
          marker.map = this.#map;
          // 波紋効果を追加
          this.#createRippleEffect(location.position, index);
        }, index * 1); // 1ms間隔で順次表示
      }

      this.#markers.push(marker);
    });
  }

  filterMarkers(e) {
    // イベントの重複実行を防ぐ
    e.preventDefault();
    e.stopPropagation();
    
    const clickedCheckbox = e.currentTarget;
    const clickedArea = clickedCheckbox.dataset.area;
    
    // console.log('Filter clicked:', clickedArea); // デバッグログ
    // console.log('Current checked state:', clickedCheckbox.dataset.checked); // デバッグログ

    // 現在のボタンの状態を確認（状態変更前に取得）
    const isCurrentlyChecked = clickedCheckbox.dataset.checked === 'true';
    
    // 'all'エリアがクリックされた場合、またはすでに選択されているボタンがクリックされた場合
    if (clickedArea === 'all' || isCurrentlyChecked) {
      // 全てのボタンのチェック状態をリセット
      const allButtons = document.querySelectorAll('.map-filter-list__trigger');
      allButtons.forEach(button => {
        button.dataset.checked = 'false';
      });
      
      // 選択を解除してデフォルト状態に戻す
      this.#createMarkersWithFilter('default');
      
      // マップの中心地点とズームをデフォルトに同時に戻す
      const centerCoords = GoogleMap.CENTER_COORDINATES['default'];
      if (centerCoords) {
        this.#map.panTo(centerCoords);
        this.#map.setZoom(centerCoords.zoom); // デフォルト時は設定されたズーム値を使用
      }
      
      // SpotControllerにデフォルト状態を通知
      if (this.spotController && this.spotController.updateFilterState) {
        this.spotController.updateFilterState('default', clickedCheckbox);
      }
      return;
    }

    // 全てのボタンのチェック状態をリセット
    const allButtons = document.querySelectorAll('.map-filter-list__trigger');
    allButtons.forEach(button => {
      button.dataset.checked = 'false';
    });
    
    // クリックされたカテゴリを選択状態にする
    clickedCheckbox.dataset.checked = 'true';

    // カテゴリに属する位置情報の中心に移動
    this.#fitAreaBounds(clickedArea);

    // マーカーを再生成（アニメーション付き）
    this.#createMarkersWithFilter(clickedArea);
    
    // SpotControllerにフィルター状態を通知
    if (this.spotController && this.spotController.updateFilterState) {
      this.spotController.updateFilterState(clickedArea, clickedCheckbox);
    }
  }

  // フィルター付きマーカー生成（アニメーション対応）
  #createMarkersWithFilter(targetArea) {
    // console.log('Creating markers for area:', targetArea); // デバッグログ
    // console.log('Available location data:', this.#locationJsonData); // デバッグログ
    
    // 既存のマーカーを完全に削除
    this.#clearAllMarkers();
    
    // 少し待ってから新しいマーカーを生成（確実にクリアするため）
    setTimeout(() => {
      // フィルタリングされたデータを取得
      const filteredData = (targetArea === 'default' || targetArea === 'all')
        ? this.#locationJsonData.filter(location => location.position !== null)  // デフォルト時または'all'時は全データを表示
        : this.#locationJsonData.filter(location => {
            // console.log(`Checking location: ${location.title}, area: ${location.area}, target: ${targetArea}`);
            return location.area === targetArea && location.position !== null;
          });
        
      // console.log('Filtered data:', filteredData); // デバッグログ
      // console.log('Filtered data count:', filteredData.length); // デバッグログ

      // 新しいマーカーを時差アニメーション付きで生成
      filteredData.forEach((location, index) => {
        const markerContent = document.createElement('div');
        markerContent.className = 'custom-pin';
        markerContent.innerHTML = GoogleMap.PIN_DATA['default'];

        const marker = new this.AdvancedMarkerElement({
          position: location.position,
          map: null, // 初期状態で非表示
          content: markerContent,
          title: location.title,
        });
        
        // マーカーにlocationDataを追加（クリックリスナーで使用）
        marker.locationData = location;

        // 時差でマーカーを表示
        setTimeout(() => {
          marker.map = this.#map;
        }, index * 1); // 1ms間隔で順次表示

        this.#markers.push(marker);
      });

      // クリックリスナーを再設定（全マーカー表示完了後）
      setTimeout(() => {
        this.#addMarkerClickListeners();
      }, filteredData.length * 1 + 100);
    }, 50); // 50ms待ってから新しいマーカーを生成
  }

  #createInformationPanel(data) {
    // ドロワーの内容をクリア
    while (this.#dom.drawerUnit.firstChild) {
      this.#dom.drawerUnit.removeChild(this.#dom.drawerUnit.firstChild);
    }

    // エリア表示用のアイコン
    const areaIconHtml = data.area ? `
      <div class="map-drawer-unit__area">
        <img src="${this.#path}assets/img/comorevimap/icon-${data.area}.svg" width="24" height="24" alt="${data.area}">
        <span class="map-drawer-unit__area-label">${this.#getAreaLabel(data.area)}</span>
      </div>
    ` : '';

    // 説明文の表示（nullの場合は非表示）
    const descriptionHtml = data.description ? `
      <div class="map-drawer-unit__description">
        <p>${data.description}</p>
      </div>
    ` : '';

    let linkTargetAttr = null;
    let linkTitle = null;
    if (data.link) {
      linkTargetAttr = data.link.target ? ` target="${data.link.target}"` : '';
      linkTitle = data.link.title ? data.link.title : i18n('linkDefault');
    }

    // ボタンエリアの表示
    const buttonsHtml = `
      <div class="map-drawer-unit__buttons">
        ${data.contents === 'movie' ? `
          <button class="map-drawer-unit-button" data-video-id="${data.movie}">
          <span class="map-drawer-unit-button__inner">
          <span class="map-drawer-unit-button__text">${i18n('watchMovie')}</span>
          <span class="map-drawer-unit-button__icon"><span></span></span>
          </span>
          </button>
        ` : ''}
        ${data.contents === 'article' ? `
          <div class="map-drawer-unit-button">
          <a href="${data.permalink}" class="map-drawer-unit-button__inner">
          <span class="map-drawer-unit-button__text">${i18n('readStory')}</span>
          <span class="map-drawer-unit-button__icon"><span></span></span>
          </a>
          </div>
        ` : ''}
        ${data.link ? `
          <div class="map-drawer-unit-button">
          <a href="${data.link.url}" class="map-drawer-unit-button__inner"${linkTargetAttr}>
          <span class="map-drawer-unit-button__text">${linkTitle}</span>
          <span class="map-drawer-unit-button__icon"><span></span></span>
          </a>
          </div>
        ` : ''}
      </div>
    `;

    const html = `
      <div class="map-drawer-unit__inner">
        <div class="map-drawer-unit__content">
          <figure class="map-drawer-unit__thumbnail">
            <span class="c-clip"><img src="${data.thumbnail}" alt="${escapeAttr(data.title)}"></span>
          </figure>
          <div class="map-drawer-unit__info">
            <h2 class="map-drawer-unit__title">${data.title}</h2>
            ${descriptionHtml}
            ${buttonsHtml}
          </div>
          <ul class="map-drawer-unit-navigation">
            <li class="map-drawer-unit-navigation-item">
              <button type="button" class="map-drawer-unit-navigation-item__button">
                <span class="map-drawer-unit-navigation-item__arrow"></span>
                <span class="map-drawer-unit-navigation-item__label">${i18n('prevSpot')}</span>
              </button>
            </li>
            <li class="map-drawer-unit-navigation-item">
              <button type="button" class="map-drawer-unit-navigation-item__button">
                <span class="map-drawer-unit-navigation-item__label">${i18n('nextSpot')}</span>
                <span class="map-drawer-unit-navigation-item__arrow"></span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    `;

    this.#dom.drawerUnit.insertAdjacentHTML('beforeend', html);
    
    // 新しく追加された閉じるボタンにイベントリスナーを追加
    const newCloseButton = this.#dom.drawerUnit.querySelector('[data-js="drawer-closer"]');
    if (newCloseButton) {
      newCloseButton.addEventListener('click', this.toggleInformationPanel.bind(this));
    }

    // 動画ボタンにイベントリスナーを追加
    const videoButton = this.#dom.drawerUnit.querySelector('[data-video-id]');
    if (videoButton) {
      videoButton.addEventListener('click', (e) => {
        const videoId = e.currentTarget.dataset.videoId;
        if (videoId && this.videoModal) {
          // 位置情報も一緒に渡す（lensページと同じ挙動）
          const lat = data.position ? data.position.lat : null;
          const lng = data.position ? data.position.lng : null;
          const municipalities = data.municipalities || null;
          const copy = data.copy || null;
          const eyecatch = data.thumbnail || null;
          this.videoModal.open(videoId, lat, lng, municipalities, copy, eyecatch);
        }
      });
    }

    // ナビゲーションの制御とイベント登録
    const currentSpots = this.#getCurrentSpots();
    this.#currentSpotIndex = currentSpots.findIndex(spot => spot.title === data.title);

    const navigationEl = this.#dom.drawerUnit.querySelector('.map-drawer-unit-navigation');
    if (navigationEl) {
      if (currentSpots && currentSpots.length > 1) {
        navigationEl.style.display = '';
      } else {
        navigationEl.style.display = 'none';
      }
    }

    const nextSpotBtn = this.#dom.drawerUnit.querySelector('.map-drawer-unit-navigation-item:nth-child(1) .map-drawer-unit-navigation-item__button');
    if (nextSpotBtn) {
      nextSpotBtn.addEventListener('click', () => {
        this.#navigateSpot('next');
      });
    }

    const prevSpotBtn = this.#dom.drawerUnit.querySelector('.map-drawer-unit-navigation-item:nth-child(2) .map-drawer-unit-navigation-item__button');
    if (prevSpotBtn) {
      prevSpotBtn.addEventListener('click', () => {
        this.#navigateSpot('prev');
      });
    }
    
    // もしドロワーが閉じていたら開く（すでに開いている場合はトグルしない）
    if (!this.#panelFlag) {
      this.toggleInformationPanel();
    }
  }

  // エリア名を表示言語のラベルに変換
  #getAreaLabel(area) {
    const areaLabels = {
      'minamiaizu': i18n('areaMinamiaizu'),
      'shimogo': i18n('areaShimogo'),
      'aizuwakamatsu': i18n('areaAizuwakamatsu')
    };
    return areaLabels[area] || area;
  }

  // 外部からドロワーを表示するためのメソッド
  showInformationPanel(data) {
    this.#createInformationPanel(data);
  }

  // 外部から明示的にドロワーを閉じるメソッド
  closeInformationPanel() {
    this.#panelFlag = false;
    if (this.#dom.drawer) {
      this.#dom.drawer.removeAttribute('data-is');
    }
  }

  // Google Maps APIと地図の遅延初期化を実行するメソッド
  async initMap() {
    if (this.#map) return;
    await this.#init();
  }

  toggleInformationPanel() {
    this.#panelFlag = !this.#panelFlag;
    if (this.#panelFlag) {
      this.#dom.drawer.dataset.is = 'open';
    } else {
      this.#dom.drawer.removeAttribute('data-is');
    }
  }

  // 公開メソッド（外から使う可能性があるものだけ）
  setCenter(lat, lng) {
    this.#map.setCenter({ lat, lng });
  }

  // アニメーション付きで中心地点を移動
  panTo(lat, lng) {
    this.#map.panTo({ lat, lng });
  }

  getCenter() {
    return this.#map.getCenter();
  }

  // マップインスタンスを取得（SpotControllerから使用）
  getMap() {
    return this.#map;
  }

  // マップコンテナのアニメーション設定
  #setupMapContainerAnimation() {
    this.#dom.el.style.opacity = '0';
    this.#dom.el.style.transform = 'scale(1.1)';
    this.#dom.el.style.transition = 'opacity 1.2s cubic-bezier(.645, .045, .355, 1), transform 1.2s cubic-bezier(.645, .045, .355, 1)';
  }

  // ローディングアニメーション表示
  #showLoadingAnimation() {
    const loadingEl = document.createElement('div');
    loadingEl.className = 'map-loading';
    loadingEl.innerHTML = `
      <div class="map-loading__spinner">
        <div class="map-loading__dot"></div>
        <div class="map-loading__dot"></div>
        <div class="map-loading__dot"></div>
      </div>
      <p class="map-loading__text">${i18n('mapLoading')}</p>
    `;
    
    // ローディング用のスタイルを動的に追加
    if (!document.querySelector('#map-loading-styles')) {
      const style = document.createElement('style');
      style.id = 'map-loading-styles';
      style.textContent = `
        .map-loading {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: rgba(255, 255, 255, 0.95);
          z-index: 1000;
          backdrop-filter: blur(2px);
        }
        .map-loading__spinner {
          display: flex;
          gap: 8px;
          margin-bottom: 16px;
        }
        .map-loading__dot {
          width: 12px;
          height: 12px;
          background: #000;
          border-radius: 50%;
          animation: mapLoadingBounce 1.4s ease-in-out infinite both;
        }
        .map-loading__dot:nth-child(1) { animation-delay: -0.32s; }
        .map-loading__dot:nth-child(2) { animation-delay: -0.16s; }
        .map-loading__text {
          color: #666;
          font-size: 14px;
          margin: 0;
        }
        @keyframes mapLoadingBounce {
          0%, 80%, 100% { transform: scale(0); }
          40% { transform: scale(1); }
        }
        .map-ripple {
          position: absolute;
          border: 2px solid #6d9f5b;
          border-radius: 50%;
          pointer-events: none;
          animation: mapRipple 1.5s ease-out;
          transform-origin: center center;
        }
        @keyframes mapRipple {
          0% {
            width: 0px;
            height: 0px;
            opacity: 1;
          }
          100% {
            width: 60px;
            height: 60px;
            opacity: 0;
          }
        }
      `;
      document.head.appendChild(style);
    }
    
    const containerEl = this.#dom.el.parentElement || this.#dom.el;
    containerEl.style.position = 'relative';
    containerEl.appendChild(loadingEl);
  }

  // ローディングアニメーション非表示
  #hideLoadingAnimation() {
    const containerEl = this.#dom.el.parentElement || this.#dom.el;
    const loadingEl = containerEl.querySelector('.map-loading');
    if (loadingEl) {
      loadingEl.style.opacity = '0';
      loadingEl.style.transition = 'opacity 0.3s ease-out';
      setTimeout(() => {
        if (loadingEl.parentNode) {
          loadingEl.parentNode.removeChild(loadingEl);
        }
      }, 300);
    }
  }

  // マップをアニメーション付きで表示
  #showMapWithAnimation() {
    setTimeout(() => {
      this.#dom.el.style.opacity = '1';
      this.#dom.el.style.transform = 'scale(1)';
    }, 100);
  }

  // 波紋効果を作成
  #createRippleEffect(position, delay = 0) {
    const overlay = new google.maps.OverlayView();
    let rippleDiv = null;
    
    overlay.onAdd = function() {
      rippleDiv = document.createElement('div');
      rippleDiv.className = 'map-ripple';
      rippleDiv.style.position = 'absolute';
      rippleDiv.style.pointerEvents = 'none';
      
      const panes = this.getPanes();
      panes.overlayLayer.appendChild(rippleDiv);
      
      // アニメーション完了後に要素を削除
      setTimeout(() => {
        if (rippleDiv && rippleDiv.parentNode) {
          rippleDiv.parentNode.removeChild(rippleDiv);
        }
      }, 1500);
    };
    
    overlay.draw = function() {
      if (!rippleDiv) return;
      
      const projection = this.getProjection();
      if (!projection) return;
      
      const pos = projection.fromLatLngToDivPixel(position);
      if (pos) {
        // ピンのサイズは64x69px、ピンの先端（地図上の実際の位置）は下部中央
        // ピンのアンカーポイント（先端）からピンの中心（円形部分）までのオフセットを計算
        // SVGを見ると、円形部分の中心はy=32付近、ピンの先端はy=60.5付近
        // 吹き出し部分を考慮して、波紋を円形部分の少し下（吹き出しの付け根付近）に配置
        const pinCenterOffsetY = -15; // ピンの先端から波紋表示位置までのオフセット（吹き出し考慮）
        
        // 波紋の中心をピンの円形部分の中心に合わせる
        rippleDiv.style.left = pos.x + 'px';
        rippleDiv.style.top = (pos.y + pinCenterOffsetY) + 'px';
        rippleDiv.style.transform = 'translate(-50%, -50%)';
      }
    };
    
    overlay.onRemove = function() {
      if (rippleDiv && rippleDiv.parentNode) {
        rippleDiv.parentNode.removeChild(rippleDiv);
      }
      rippleDiv = null;
    };
    
    overlay.setMap(this.#map);
    
    // 一定時間後にオーバーレイを削除
    setTimeout(() => {
      overlay.setMap(null);
    }, 2000);
  }

  #fitAreaBounds(targetArea) {
    if (targetArea === 'default' || targetArea === 'all') {
      const centerCoords = GoogleMap.CENTER_COORDINATES['default'];
      this.#map.panTo(centerCoords);
      this.#map.setZoom(centerCoords.zoom);
      return;
    }

    const areaLocations = this.#locationJsonData.filter(
      location => location.area === targetArea && location.position !== null
    );

    if (areaLocations.length === 0) {
      const fallback = GoogleMap.CENTER_COORDINATES[targetArea] || GoogleMap.CENTER_COORDINATES['default'];
      this.#map.panTo(fallback);
      this.#map.setZoom(fallback.zoom || GoogleMap.CENTER_COORDINATES['default'].zoom);
      return;
    }

    const bounds = new google.maps.LatLngBounds();
    areaLocations.forEach(location => {
      bounds.extend(new google.maps.LatLng(location.position.lat, location.position.lng));
    });
    this.#map.fitBounds(bounds);
  }

  #getCurrentSpots() {
    const data = (this.spotController && this.spotController.getFilteredData)
      ? this.spotController.getFilteredData()
      : this.#locationJsonData;
    if (this.spotController && this.spotController.getCurrentView() === 'map') {
      return data.filter(location => location.position !== null);
    }
    return data;
  }

  #navigateSpot(direction) {
    const currentSpots = this.#getCurrentSpots();
    if (!currentSpots || currentSpots.length <= 1) return;

    if (direction === 'next') {
      this.#currentSpotIndex = (this.#currentSpotIndex - 1 + currentSpots.length) % currentSpots.length;
    } else if (direction === 'prev') {
      this.#currentSpotIndex = (this.#currentSpotIndex + 1) % currentSpots.length;
    }

    const nextSpot = currentSpots[this.#currentSpotIndex];
    if (nextSpot) {
      this.#createInformationPanel(nextSpot);

      // マップビューの場合は、地図の中心を新しいスポットに移動
      if (this.spotController && this.spotController.getCurrentView() === 'map') {
        if (nextSpot.position) {
          const lat = parseFloat(nextSpot.position.lat);
          const lng = parseFloat(nextSpot.position.lng);
          this.panTo(lat, lng);
        }
      }
    }
  }
}

export default GoogleMap;